import type { Feature } from "ol";
import type { Geometry } from "ol/geom";
import { ShapeMode } from "./shapeMode";

const shapeIdKey = 'shapeId';

export function getShapeId(feature: Feature<Geometry>) {
  return getGeoJsonPropertyText(feature, shapeIdKey);
}

export function getGeoJsonPropertyText(feature: Feature<Geometry>, name: string) {
  const properties = feature.getProperties();
  if (!properties) return;
  const value = properties[name];
  if (typeof value === 'string') return value;
}

const storageAreaIdKey = 'storageAreaId';

export function getStorageAreaId(feature: Feature<Geometry>) {
  return getGeoJsonPropertyText(feature, storageAreaIdKey);
}

const modeKey = 'mode';

export function getMode(feature: Feature<Geometry>) {
  const text = getGeoJsonPropertyText(feature, modeKey);
  switch (text) {
    case 'polygon':
      return ShapeMode.Polygon;
  }

  return ShapeMode.Rectangle;
}
